import React from "react";
import LandingSlider from "../section/LandingSlider";
import Categories from "../section/Categories";
import RecommendedSection from "../section/RecommendedSection";
export default function Home() {
    return (
       <>
        <LandingSlider/>
        <Categories/>
        <RecommendedSection/>
       </>
    );
}